// ./src/components/generic/ColorSwatch/ColorSwatch.tsx
//
// A small rounded color square for showing a chosen color in lists, cards,
// pickers, etc. App-styled with a sensible fallback when no color is set.
// (This is our lightweight, fallback-aware swatch — Mantine's own ColorSwatch
// is heavier and doesn't provide an app default.)

import React from "react";
import { Box } from "@mantine/core";

export interface ColorSwatchProps {
  /** The color to show (any CSS color). */
  color?: string | null;
  /** Square size in px. */
  size?: number;
  /** Corner radius — a CSS length or a Mantine radius CSS var. */
  radius?: string | number;
  /** Fallback color when `color` is empty. */
  fallback?: string;
  style?: React.CSSProperties;
}

const DEFAULT_FALLBACK = "#6B7280";

const ColorSwatchComponent: React.FC<ColorSwatchProps> = ({
  color,
  size = 32,
  radius = "var(--mantine-radius-sm)",
  fallback = DEFAULT_FALLBACK,
  style,
}) => (
  <Box
    style={{
      width: size,
      height: size,
      borderRadius: radius,
      backgroundColor: color || fallback,
      flexShrink: 0,
      ...style,
    }}
  />
);

export const ColorSwatch = React.memo(ColorSwatchComponent);
